const apiConfig = {
  apiPath: process.env.REACT_APP_API_PATH || "/api",
  version: process.env.REACT_APP_API_VERSION || "/v1",
  apiModule: process.env.REACT_APP_API_MODULE || "/admin",
};
const apiPrefix = `${apiConfig.apiPath}${apiConfig.version}${apiConfig.apiModule}`;


module.exports = {
  api: {
    api_base: process.env.REACT_APP_API_URL || "http://localhost:5000",
    api_prefix_version: apiPrefix,
  },
  s3: {
    host: process.env.REACT_APP_S3_DOMAIN || "",
  },
  admin_host_url: process.env.REACT_APP_ADMIN_URL || "http://localhost:3000",
  encryption_key: process.env.REACT_APP_ENCRYPTION_KEY,
  initialization_vector: process.env.REACT_APP_INITIALIZATION_VECTOR,
  constant: {
    encrypt: "encrypt",
    decrypt: "decrypt",
  },
  pm2Cmd: process.env.REACT_APP_PM2_CMD_NAME || "next-start-cmd",
};